import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { UntypedFormGroup as FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subscription } from 'rxjs';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { CLIENT_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/client';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { ClientStoreService } from '../../../../../state/modules/client/client-store.service';
import { TimesheetService } from '../../../../../state/modules/timesheet/services/timesheet.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { ScanTaskGroupFormsComponent } from '../scan-task-group-forms/scan-task-group-forms.component';
import { SCAN_AREA_FORM_CONTROLS } from './start-area.constant';
import { NotificationComponent } from '../../../../shared/components/modals/notification/notification.component';
import { ModalButtonType, ModalType } from '../../../../../models/common/modal/modal-config';

@Component({
  standalone: false,
  selector: 'kt-scan-area',
  templateUrl: './scan-area.component.html',
  styleUrls: ['./scan-area.component.scss'],
})
export class ScanAreaComponent extends ModalBaseClass implements OnInit, OnDestroy {

  buttonConfig = BUTTON_CONFIG;
  formConstants = SCAN_AREA_FORM_CONTROLS;
  scanAreaForm = new FormGroup({});
  shiftInfo: any = null;
  allArea = [];
  lookup = {
    area: new BehaviorSubject<any[]>([]),
  };
  user_id = 0;
  loading = signal(false);
  private isPatrolScan = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private clientStoreService: ClientStoreService,
    private timesheetService: TimesheetService,
    public activeModal: NgbActiveModal,
    private ngbModal: NgbModal,
  ) {
    super(ngbModal);
  }


  ngOnInit() {
    this.dispatchAreaAllList(this.shiftInfo.client.client_id, this.shiftInfo.location.location_id);
  }


  saveClickHandler() {
    if (this.loading()) {
      return;
    }
    if (this.scanAreaForm.invalid) {
      setTimeout(() => {
        this.scanAreaForm.markAllAsTouched();
      });

      return;
    }
    const areaId = this.scanAreaForm.value.area_id;
    const selectedArea = this.allArea.find(area => area.area_id === areaId);
    const timesheetId = this.shiftInfo && this.shiftInfo.timesheet ? this.shiftInfo.timesheet.timesheet_id : 0;

    if (timesheetId > 0) {
      this.loading.set(true);
      this.subscriptions.push(
        this.timesheetService.checkPatrolScanDuplicate({ timesheet_id: timesheetId, area_id: areaId }).subscribe({
          next: (response: any) => {
            this.loading.set(false);
            if (response.success && response.data && response.data.data && response.data.data.patrol_scan_check) {
              const scanCheck = response.data.data.patrol_scan_check;
              this.isPatrolScan = scanCheck.is_patrol_scan === true;
              if (scanCheck.is_patrol_scan && (scanCheck.is_duplicate_by_other || scanCheck.is_duplicate_by_self)) {
                this.showDuplicateConfirmation(scanCheck, areaId, selectedArea);
                return;
              }
            }
            this.openScanTaskGroupForms(areaId, selectedArea);
          },
          error: () => {
            this.loading.set(false);
            this.openScanTaskGroupForms(areaId, selectedArea);
          }
        })
      );
    } else {
      this.openScanTaskGroupForms(areaId, selectedArea);
    }
  }

  showDuplicateConfirmation(scanCheck: any, areaId: number, selectedArea: any) {
    const slotTime = scanCheck.slot_start_time && scanCheck.slot_end_time
      ? ` (${scanCheck.slot_start_time} - ${scanCheck.slot_end_time})`
      : '';
    const duplicateMsg = scanCheck.is_duplicate_by_self
      ? `You have already scanned this patrol slot${slotTime}. Do you want to scan again?`
      : `This patrol slot${slotTime} is already completed by ${scanCheck.completed_by_user_name}. Do you want to continue?`;
    const modalRef = this.ngbModal.open(NotificationComponent, { centered: true });
    modalRef.componentInstance.options = {
      type: ModalType.WARNING,
      title: 'Patrol Scan',
      message: duplicateMsg,
      buttons: {
        button2: { text: 'Cancel' },
        button1: { text: 'Yes, Continue' },
      }
    };
    modalRef.result.then((res) => {
      if (res && res.STATUS === ModalButtonType.OK) {
        this.openScanTaskGroupForms(areaId, selectedArea);
      }
    }).catch(() => { });
  }

  openScanTaskGroupForms(areaId: number, selectedArea: any) {
    const compRef = this.openPopUp(ScanTaskGroupFormsComponent, { shiftInfo: this.shiftInfo, areaId, area: selectedArea, user_id: this.user_id, isPatrolScan: this.isPatrolScan }, { centered: true, size: 'lg', backdrop: 'static' });
    compRef.result.then((res) => {
      this.activeModal.close(res);
    }).catch(() => {
      this.activeModal.close();
    });
  }


  getAreaAllList(data) {
    if (data.success) {
      this.lookup.area.next(data.data.data.areas || []);
      this.allArea = (data.data.data.areas);
    }
  }

  dispatchAreaAllList(clientId, locationId) {
    this.clientStoreService.dispatchClientCommon({
      callback: this.getAreaAllList.bind(this), data: { clientId, locationId },
      module: CLIENT_METHOD_CONSTANT.CLIENT_AREA,
      method: API_METHOD_CONSTANTS.GET_LOOKUP,
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

}
